import "./style.less"

import { Radio, Select } from "antd"
import { FormattedMessage, useIntl } from "react-intl"
import { Field } from "redux-form"
import { mustBeDecimal, required } from "src/forms/validators"
import {
  DateField,
  InputField,
  RadioGroupField,
  SelectField,
  SwitchField,
} from "src/inputs/connected-input-fields"
import {
  CHANGED_DOCUMENT_OPTIONS,
  CHANGED_DOCUMENT_OPTIONS_PROCESSES,
  ChangeType,
  REASON_FOR_CHANGE_OPTIONS,
} from "src/globals"
import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import { Maybe } from "../../../types"

const { Option } = Select

type ChangeLogFieldsProps = {
  changeToFieldName?: string
  updateType?: Maybe<"major" | "minor">
  changeType?: Maybe<ChangeType>
  docDisabled?: boolean
  disabledEditorialVersion?: boolean
  nextReviewDateIsApplicable?: Maybe<boolean>
  isLoading?: boolean
  tree: string
}

export default function ChangeLogFields({
  changeToFieldName,
  updateType,
  changeType,
  docDisabled = false,
  disabledEditorialVersion = false,
  nextReviewDateIsApplicable = false,
  isLoading = false,
  tree,
}: ChangeLogFieldsProps) {
  const intl = useIntl()

  const changes =
    tree == "processes"
      ? Object.values(CHANGED_DOCUMENT_OPTIONS_PROCESSES).map((change, index) => ({
          ...change,
          value: index + 1,
        }))
      : Object.values(CHANGED_DOCUMENT_OPTIONS).map((change, index) => ({
          ...change,
          value: index + 1,
        }))

  return (
    <>
      {updateType && (
        <div className="changeToOptions">
          <Field
            name={changeToFieldName || "changeTo"}
            className="radio-group-document"
            component={RadioGroupField}
            validate={[required]}
            disabled={docDisabled || isLoading}
            button
            label={<FormattedMessage id="form.notification.changeTo" />}
          >
            {changes.map((change, _index) => (
              <Radio key={change.radiovalue} value={change.radiovalue}>
                <FormattedMessage id={change.label} />
                <p className="details">
                  {change.inchangelog ? (
                    <FormattedMessage id="form.notification.changeTo.inChangeLog" />
                  ) : change.innotifications ? (
                    <FormattedMessage id="form.notification.changeTo.notInChangeLog" />
                  ) : (
                    <FormattedMessage id="form.notification.changeTo.notInChangeLogAndNotifications" />
                  )}
                </p>
              </Radio>
            ))}
          </Field>
        </div>
      )}

      {changeType === ChangeType.DOCUMENT && (
        <>
          <p className="radio-group-document-warning">
            <FormattedMessage
              id="form.notification.changeTo.description"
              values={{
                strong: (chunk) => <strong>{chunk}</strong>,
              }}
            />
          </p>
          <Field
            name="editorialVersion"
            component={InputField}
            validate={[mustBeDecimal, required]}
            required
            label={`${intl.formatMessage({ id: "common.editorialVersion" })}`}
            disabled={disabledEditorialVersion || isLoading}
          />
        </>
      )}

      {(changeType === ChangeType.DOCUMENT || changeType === ChangeType.SUPPORTING_DOCUMENT) && (
        <div className="publish-version-form__details fade-in">
          <div className="ant-form-item-label">
            <label className={nextReviewDateIsApplicable ? "ant-form-item-required" : ""}>
              <FormattedMessage id="common.nextReviewDate" />
            </label>
          </div>
          <div className="next-review-date-field">
            <Field
              name="nextReviewDateIsApplicable"
              component={SwitchField}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
            />
            <Field
              name="nextReviewDate"
              component={DateField}
              mode="day"
              disabled={!nextReviewDateIsApplicable}
              validate={nextReviewDateIsApplicable ? [required] : []}
            />
          </div>
        </div>
      )}

      {(changeType === ChangeType.DOCUMENT || changeType === ChangeType.SUPPORTING_DOCUMENT) && (
        <div className="publish-version-form__details fade-in">
          <Field
            name="reasonForChange"
            className="publish-version-form__input"
            component={SelectField}
            disabled={isLoading}
            label={intl.formatMessage({ id: "draft.documents.minormajor.reasonForChange" })}
            placeholder={intl.formatMessage({
              id: "draft.documents.minormajor.reasonForChange.placeHolder",
            })}
            validate={[required]}
            required
          >
            {REASON_FOR_CHANGE_OPTIONS.map((reason) => (
              <Option key={reason.value} value={reason.value}>
                <FormattedMessage id={reason.label} />
              </Option>
            ))}
          </Field>

          <Field
            name="changeLog"
            className="publish-version-form__input"
            component={InputField}
            label={intl.formatMessage({ id: "draft.documents.minormajor.changeLog" })}
            placeholder={intl.formatMessage({
              id: "draft.documents.minormajor.changeLog.placeholder",
            })}
            disabled={isLoading}
            validate={[required]}
            required
          />
          {/*<Field
            name="howTo"
            className="publish-version-form__input"
            component={FormInput}
            disabled={isLoading}
            label={intl.formatMessage({ id: "draft.documents.minormajor.howTo" })}
            placeholder={intl.formatMessage({ id: "draft.documents.minormajor.howTo.placeholder" })}
          />
          <Field
            name="text"
            className="publish-version-form__textarea"
            component={TextAreaField}
            label={intl.formatMessage({ id: "draft.documents.minormajor.text" })}
            placeholder={intl.formatMessage({ id: "draft.documents.minormajor.text.placeholder" })}
            validate={[]}
          /> */}
        </div>
      )}
    </>
  )
}
